import {Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {NavigationStart, Router} from "@angular/router";
import {Subscription} from "rxjs";
import {FabButtonService} from "./fab-button.service";
import {getPathWithoutQueryAndHash} from "../utils/url.utils";
import { CommonModule, Location, NgClass } from "@angular/common";
import {OverlayService} from "./overlay.service";
import {DeviceDetectService} from "../../services/device-detect.service";
import {TranslatePipe} from "@ngx-translate/core";
import {MatIcon} from "@angular/material/icon";
import {MatFabButton} from "@angular/material/button";
import {MatTooltip} from "@angular/material/tooltip";
import {UserInfoService} from "../../services/user-info.service";


@Component({
    selector: "app-fab-button",
    templateUrl: "./fab-button.component.html",
    styleUrls: ["./fab-button.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatFabButton,
    NgClass,
    MatIcon,
    CommonModule,
    TranslatePipe,
    MatTooltip
  ]
})
export class FabButtonComponent implements OnInit, OnDestroy {

  @Input() button!: string;
  isVisible = true;
  isMyHealthPlan = false;
  isMyDiary = false;
  isMainMenu = false;
  isMyHealth = false;
  isActivityReport = false;
  atLocation!: NavigationStart;
  isSubMenuOpen = false;
  hasActivePlan!: boolean;
  private subs: Subscription[] = [];
  isMobile = false;
  isExternalPatient = false;

  constructor(private router: Router,
              private location: Location,
              private overlay: OverlayService,
              private fabButtonService: FabButtonService,
              private deviceDetect: DeviceDetectService,
              private userInfoService: UserInfoService) {
  }

  ngOnInit(): void {
    this.isMobile = this.deviceDetect.isMobile;
    this.isExternalPatient = this.userInfoService.getIsExternalPatient();
    this.updateRouteFlags(getPathWithoutQueryAndHash(this.router.url));
    let subMenuSub = this.fabButtonService.isSubMenuOpen.subscribe(data => this.isSubMenuOpen = data);
    let hasActivePlanSub = this.fabButtonService.hasActiveHealthPlan.subscribe(data => {
      this.hasActivePlan = data;
    });
    let shouldShowSub = this.fabButtonService.shouldShowFAB.subscribe(data => {
      this.isVisible = data;
    });

    let atLocationSub = this.fabButtonService.atLocation.subscribe((data) => {
      this.atLocation = data;
      this.isMyHealthPlan = false;
      this.isMyDiary = false;
      this.isMainMenu = false;
      this.isMyHealth = false;
      this.isActivityReport = false;
      this.updateRouteFlags(getPathWithoutQueryAndHash(this.atLocation?.url ?? ""));
    });
    this.subs.push(...[shouldShowSub, subMenuSub, hasActivePlanSub, atLocationSub]);
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  goToLocation(url: string) {
    this.router.navigate([this.location.path() + url]);
  }

  openSubMenu() {
    this.fabButtonService.isSubMenuOpen.next(true);
    this.overlay.open();
  }

  private updateRouteFlags(path: string) {
    if (path.includes("health-plan")) {
      this.isMyHealthPlan = true;
    } else if (path.includes("diary")) {
      this.isMyDiary = true;
    } else if (path === "/") {
      this.isMainMenu = true;
    } else if (path === "/my-health") {
      this.isMyHealth = true;
    }
    if (path.includes("/health-plan/new")) {
      this.isActivityReport = true;
    } else {
      return;
    }
  }

  // when user is done adding new activity report
  saveAndGoBack() {
    // we actually don't save, everything was already saved on each action, we just go back
    this.location.back();
  }
}
